<div class="checks-report-root">
  <div class="report-container">
    <div class="report-shell">

      <!-- Header -->
      <header class="report-page-header">
        <a routerLink="/dashboard/merchant-info" [queryParams]="{ openReports: '1' }" class="report-back-link">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
          {{ translate.instant('merchant-info.common.back') }}
        </a>
        <div class="report-page-heading">
          <h1>{{ translate.instant('checksReport.title') }}</h1>
          <p class="report-page-sub">{{ translate.instant('checksReport.subtitle') }}</p>
        </div>
        <div class="report-page-actions">
          <button type="button" class="btn-refresh" (click)="loadReport()" [disabled]="loading || !companyId">
            <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
            {{ translate.instant('checksReport.actions.refresh') }}
          </button>
        </div>
      </header>

      <div class="alert alert-warning report-alert" *ngIf="!companyId">
        <i class="fa fa-exclamation-triangle"></i>
        {{ translate.instant('checksReport.warnings.no_company') }}
      </div>

      <!-- Toolbar: period + filters -->
      <section class="toolbar-panel">
        <div class="toolbar-block">
          <span class="toolbar-label">{{ translate.instant('checksReport.period.label') }}</span>
          <div class="period-segment">
            <button
              type="button"
              class="segment-btn"
              [class.active]="period === 'all_future'"
              (click)="setPeriod('all_future')">
              <i class="fa fa-calendar-check-o"></i>
              {{ translate.instant('checksReport.period.all_future') }}
            </button>
            <button
              type="button"
              class="segment-btn"
              [class.active]="period === 'next_7_days'"
              (click)="setPeriod('next_7_days')">
              <i class="fa fa-clock-o"></i>
              {{ translate.instant('checksReport.period.next_7_days') }}
            </button>
            <button
              type="button"
              class="segment-btn"
              [class.active]="period === 'custom'"
              (click)="setPeriod('custom')">
              <i class="fa fa-sliders"></i>
              {{ translate.instant('checksReport.period.custom') }}
            </button>
          </div>
        </div>

        <div class="toolbar-dates" *ngIf="period === 'custom'">
          <label class="field">
            <span>{{ translate.instant('checksReport.filters.fromDate') }}</span>
            <p-calendar
              [(ngModel)]="customFromDate"
              styleClass="checks-calendar"
              showIcon="true"
              dateFormat="dd/mm/yy"
              placeholder="DD/MM/YYYY"
              (ngModelChange)="onCustomDateChange(); loadReport()">
            </p-calendar>
          </label>
          <label class="field">
            <span>{{ translate.instant('checksReport.filters.toDate') }}</span>
            <p-calendar
              [(ngModel)]="customToDate"
              styleClass="checks-calendar"
              showIcon="true"
              dateFormat="dd/mm/yy"
              placeholder="DD/MM/YYYY"
              (ngModelChange)="onCustomDateChange(); loadReport()">
            </p-calendar>
          </label>
        </div>
        <div class="alert alert-danger toolbar-error" *ngIf="dateRangeError">{{ dateRangeError }}</div>

        <div class="toolbar-filters">
          <label class="field field--company">
            <span>{{ translate.instant('checksReport.filters.company') }}</span>
            <p-dropdown
              [options]="companyData"
              optionLabel="label"
              optionValue="company_id"
              [(ngModel)]="companyId"
              styleClass="checks-dropdown"
              [placeholder]="translate.instant('checksReport.filters.selectCompany')"
              appendTo="body"
              (onChange)="onCompanyChange()">
            </p-dropdown>
          </label>
          <label class="field">
            <span>{{ translate.instant('checksReport.filters.status') }}</span>
            <p-dropdown
              [options]="statusFilterOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="checkStatusFilter"
              styleClass="checks-dropdown"
              appendTo="body"
              (onChange)="onStatusFilterChange()">
            </p-dropdown>
          </label>
          <label class="field field--search">
            <span>{{ translate.instant('checksReport.filters.search') }}</span>
            <div class="search-row">
              <div class="search-wrap">
                <i class="fa fa-search search-icon"></i>
                <input
                  type="text"
                  class="search-input"
                  [(ngModel)]="searchKeyword"
                  (keydown)="onSearchKeydown($event)"
                  [placeholder]="translate.instant('checksReport.filters.searchPlaceholder')" />
              </div>
              <button
                type="button"
                class="btn-search"
                (click)="applySearch()"
                [disabled]="loading || !companyId">
                <i class="fa fa-search"></i>
                {{ translate.instant('checksReport.filters.searchButton') }}
              </button>
            </div>
          </label>
          <label class="field field--toggle">
            <span class="toggle-label">{{ translate.instant('checksReport.filters.includeCancelled') }}</span>
            <div class="toggle-wrap">
              <input
                class="toggle-input"
                type="checkbox"
                id="includeCancelled"
                [(ngModel)]="includeCancelled"
                (change)="onIncludeCancelledChange()" />
              <label class="toggle-switch" for="includeCancelled"></label>
            </div>
          </label>
        </div>
      </section>

      <!-- KPI cards -->
      <section class="kpi-grid" *ngIf="summary">
        <article class="kpi-card kpi-card--warn">
          <div class="kpi-icon"><i class="fa fa-bolt"></i></div>
          <div class="kpi-body">
            <span class="kpi-label">{{ translate.instant('checksReport.summary.total7Days') }}</span>
            <span class="kpi-value">{{ formatNumber(summary.total_due_within_7_days) }} <small>₪</small></span>
          </div>
        </article>
        <article class="kpi-card kpi-card--primary">
          <div class="kpi-icon"><i class="fa fa-line-chart"></i></div>
          <div class="kpi-body">
            <span class="kpi-label">{{ translate.instant('checksReport.summary.totalFuture') }}</span>
            <span class="kpi-value">{{ formatNumber(summary.total_all_future_checks) }} <small>₪</small></span>
          </div>
        </article>
        <article class="kpi-card kpi-card--neutral">
          <div class="kpi-icon"><i class="fa fa-list-ol"></i></div>
          <div class="kpi-body">
            <span class="kpi-label">{{ translate.instant('checksReport.summary.checksCount') }}</span>
            <span class="kpi-value kpi-value--int">{{ summary.checks_count }}</span>
          </div>
        </article>
        <article class="kpi-card kpi-card--highlight" *ngIf="summary.nearest_due_check as nearest">
          <div class="kpi-icon"><i class="fa fa-star"></i></div>
          <div class="kpi-body">
            <span class="kpi-label">{{ translate.instant('checksReport.summary.nearestCheck') }}</span>
            <div class="kpi-nearest">
              <strong>#{{ nearest.check_number }}</strong>
              <span>{{ nearest.customer_name }}</span>
              <span class="kpi-nearest-meta">
                {{ nearest.due_date }} ·
                <em [class]="daysUntilDueClass(nearest.days_until_due)">
                  {{ nearest.days_until_due }} {{ translate.instant('checksReport.table.days') }}
                </em>
                · {{ formatNumber(nearest.amount) }} ₪
              </span>
            </div>
          </div>
        </article>
      </section>

      <!-- Charts -->
      <section class="insights-row" *ngIf="rows.length">
        <article class="insight-panel">
          <header class="insight-head">
            <h2>{{ translate.instant('checksReport.charts.byDueDate') }}</h2>
            <span class="insight-hint">{{ translate.instant('checksReport.charts.currentPageHint') }}</span>
          </header>
          <div class="bar-chart">
            <div class="bar-row" *ngFor="let bar of chartBars">
              <span class="bar-label">{{ bar.label }}</span>
              <div class="bar-track">
                <div class="bar-fill" [style.width.%]="bar.pct"></div>
              </div>
              <span class="bar-amount">{{ formatNumber(bar.amount) }}</span>
            </div>
            <p class="chart-empty" *ngIf="!chartBars.length">—</p>
          </div>
        </article>
        <article class="insight-panel">
          <header class="insight-head">
            <h2>{{ translate.instant('checksReport.charts.byStatus') }}</h2>
          </header>
          <div class="status-bars">
            <div class="status-bar-row" *ngFor="let item of chartStatuses">
              <div class="status-bar-head">
                <span class="status-dot" [style.background]="item.color"></span>
                <span class="status-name">{{ item.label }}</span>
                <span class="status-meta">{{ item.count }} · {{ formatNumber(item.amount) }} ₪</span>
              </div>
              <div class="status-track">
                <div class="status-fill" [style.width.%]="item.pct" [style.background]="item.color"></div>
              </div>
            </div>
          </div>
        </article>
      </section>

      <!-- Table -->
      <section class="table-section">
        <header class="table-section-head">
          <h2>{{ translate.instant('checksReport.table.sectionTitle') }}</h2>
          <span class="table-count" *ngIf="total > 0">{{ total }} {{ translate.instant('checksReport.table.records') }}</span>
        </header>

        <!-- Desktop table -->
        <div class="table-wrapper desktop-table">
          <table class="checks-table">
            <thead>
              <tr>
                <th [class]="getSortClass('due_date')" (click)="onSortColumn('due_date')">
                  {{ translate.instant('checksReport.table.dueDate') }} <span class="sort-arrow"></span>
                </th>
                <th [class]="getSortClass('check_number')" (click)="onSortColumn('check_number')">
                  {{ translate.instant('checksReport.table.checkNumber') }} <span class="sort-arrow"></span>
                </th>
                <th [class]="getSortClass('amount')" (click)="onSortColumn('amount')">
                  {{ translate.instant('checksReport.table.amount') }} <span class="sort-arrow"></span>
                </th>
                <th [class]="getSortClass('customer_name')" (click)="onSortColumn('customer_name')">
                  {{ translate.instant('checksReport.table.customer') }} <span class="sort-arrow"></span>
                </th>
                <th class="col-bank">{{ translate.instant('checksReport.table.bankDetails') }}</th>
                <th>{{ translate.instant('checksReport.table.receiptNumber') }}</th>
                <th>{{ translate.instant('checksReport.table.status') }}</th>
                <th [class]="getSortClass('days_until_due')" (click)="onSortColumn('days_until_due')">
                  {{ translate.instant('checksReport.table.daysUntilDue') }} <span class="sort-arrow"></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="8" class="state-cell">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ translate.instant('checksReport.loading') }}
                </td>
              </tr>
              <tr *ngIf="!loading && !rows.length">
                <td colspan="8" class="state-cell state-cell--empty">
                  <i class="fa fa-inbox"></i>
                  {{ translate.instant('checksReport.table.empty') }}
                </td>
              </tr>
              <tr *ngFor="let row of rows" [class.row-updating]="updatingCheckId === row.check_id">
                <td class="cell-date">{{ row.due_date }}</td>
                <td class="cell-mono">{{ row.check_number }}</td>
                <td class="cell-amount">{{ formatNumber(row.amount) }} ₪</td>
                <td class="cell-customer">{{ row.customer_name }}</td>
                <td class="cell-bank">
                  <span class="bank-line">{{ row.bank_name }}</span>
                  <span class="bank-sub">{{ row.branch_name }} · {{ row.account_number }}</span>
                </td>
                <td>
                  <button type="button" class="receipt-link" (click)="openReceipt(row)">
                    <i class="fa fa-external-link"></i>
                    {{ row.receipt_number }}
                  </button>
                </td>
                <td class="cell-status">
                  <select
                    class="status-pill-select"
                    [ngClass]="statusBadgeClass(row.check_status)"
                    [ngModel]="row.check_status"
                    [disabled]="updatingCheckId === row.check_id"
                    (ngModelChange)="updateCheckStatus(row, $event)">
                    <option *ngFor="let opt of statusOptions" [ngValue]="opt.value">
                      {{ translate.instant('checksReport.status.' + opt.labelKey) }}
                    </option>
                  </select>
                </td>
                <td>
                  <span class="days-pill" [ngClass]="daysUntilDueClass(row.days_until_due)">
                    {{ row.days_until_due }} {{ translate.instant('checksReport.table.days') }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile cards -->
        <div class="mobile-cards" *ngIf="loading">
          <p class="state-cell">
            <i class="fa fa-spinner fa-spin"></i>
            {{ translate.instant('checksReport.loading') }}
          </p>
        </div>
        <div class="mobile-cards" *ngIf="!loading && rows.length">
          <article class="mcard" *ngFor="let row of rows">
            <div class="mcard-main">
              <div class="mcard-top">
                <span class="mcard-check">#{{ row.check_number }}</span>
                <span class="days-pill" [ngClass]="daysUntilDueClass(row.days_until_due)">
                  {{ row.days_until_due }}d
                </span>
              </div>
              <div class="mcard-customer">{{ row.customer_name }}</div>
              <div class="mcard-meta">
                <span>{{ row.due_date }}</span>
                <span class="mcard-amount">{{ formatNumber(row.amount) }} ₪</span>
              </div>
              <div class="mcard-bank">{{ row.bank_name }} · {{ row.account_number }}</div>
            </div>
            <div class="mcard-actions">
              <button type="button" class="receipt-link receipt-link--sm" (click)="openReceipt(row)">
                {{ row.receipt_number }}
              </button>
              <select
                class="status-pill-select status-pill-select--sm"
                [ngClass]="statusBadgeClass(row.check_status)"
                [ngModel]="row.check_status"
                [disabled]="updatingCheckId === row.check_id"
                (ngModelChange)="updateCheckStatus(row, $event)">
                <option *ngFor="let opt of statusOptions" [ngValue]="opt.value">
                  {{ translate.instant('checksReport.status.' + opt.labelKey) }}
                </option>
              </select>
            </div>
          </article>
        </div>
        <div class="mobile-cards mobile-cards--empty" *ngIf="!loading && !rows.length">
          <p class="state-cell state-cell--empty">
            <i class="fa fa-inbox"></i>
            {{ translate.instant('checksReport.table.empty') }}
          </p>
        </div>
      </section>

      <!-- Pagination -->
      <footer class="pagination-bar" *ngIf="total > 0">
        <div class="pagination-left">
          <span>{{ translate.instant('checksReport.pagination.show') }}</span>
          <select class="limit-select" [(ngModel)]="limit" (change)="onLimitChange()">
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <span>{{ translate.instant('checksReport.pagination.entries') }}</span>
        </div>
        <div class="pagination-center">
          {{ translate.instant('checksReport.pagination.range', {
            start: offset + 1,
            end: offset + rows.length,
            total: total
          }) }}
        </div>
        <nav class="pagination-nav" aria-label="Pagination">
          <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="onPageChange(1)">
            <i class="fa fa-angle-double-right"></i>
          </button>
          <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
            <i class="fa fa-angle-right"></i>
          </button>
          <ng-container *ngFor="let p of getPageNumbers()">
            <button
              type="button"
              *ngIf="p !== '...'"
              class="page-btn page-num"
              [class.active]="p === currentPage"
              (click)="onPageChange(+p)">
              {{ p }}
            </button>
            <span *ngIf="p === '...'" class="page-gap">…</span>
          </ng-container>
          <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
            <i class="fa fa-angle-left"></i>
          </button>
          <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(totalPages)">
            <i class="fa fa-angle-double-left"></i>
          </button>
        </nav>
      </footer>

    </div>
  </div>
</div>
